import { Paper } from '@here/components'
import { useLastSeen } from '@state'
import type { ParentProps } from 'solid-js'
import { css } from 'styled-system/css'
import { Grid } from 'styled-system/jsx'
import Channels from './Channels'
import Header from './Header'
import Setups from './Setups'
import { Heading } from '@components'

export default function (props: ParentProps) {
	useLastSeen()

	return (
		<Grid
			gridTemplateColumns={{
				base: '450px 1fr',
				xlDown: '350px 1fr',
				lgDown: '1fr',
			}}
			gap={2}
		>
			<Paper
				class={css({
					display: {
						base: 'grid',
						lgDown: 'none',
					},
					gap: 2,
					alignItems: 'start',
				})}
			>
				<Heading
					children="Chats"
					size="xs"
				/>
				<Channels />
				<Heading
					children="Setups"
					size="xs"
				/>
				<Setups />
			</Paper>
			<Grid>
				<Header />
				{props.children}
			</Grid>
		</Grid>
	)
}
